const Config = {
  base_url: window._env.API_URL,
};

export default Config;